<template>
  <v-dialog v-model="dialog" width="500">
    <v-card>
      <v-card-title>
        {{ __("detalhes") }}
        <v-spacer></v-spacer>
        <v-btn @click="handleClose" icon>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-simple-table v-if="video_call">
          <div class="subtitle mx-4 mt-7">{{ __("chamada") }}</div>
          <tbody>
            <tr>
              <th width="200px">Key</th>
              <td>
                {{ video_call.key }}
              </td>
            </tr>
            <tr>
              <th>Status</th>
              <td>
                <v-chip small label>
                  {{ video_call.status }}
                </v-chip>
              </td>
            </tr>
            <tr>
              <th>{{ __("início marcado") }}</th>
              <td>{{ video_call.starts_at }}</td>
            </tr>
            <tr>
              <th>{{ __("início real") }}</th>
              <td>{{ video_call.started_at }}</td>
            </tr>
            <tr>
              <th>{{ __("término às") }}</th>
              <td>
                {{ video_call.finished_at || "---" }}
              </td>
            </tr>
            <tr>
              <th>{{ __("link expira às") }}</th>
              <td>
                {{ video_call.expires_at || "---" }}
              </td>
            </tr>
          </tbody>
          <div class="subtitle mx-4 mt-7">{{ __("participante") }}</div>
          <tbody>
            <tr>
              <th>{{ __("contacto") }}</th>
              <td>
                {{ video_call.callee_phone || "---" }}
              </td>
            </tr>
          </tbody>
          <div class="subtitle mx-4 mt-7">{{ __("convite") }}</div>
          <tbody>
            <tr>
              <th>{{ __("enviado às") }}</th>
              <td>
                {{ video_call.invite_sent_at || __("não enviado") }}
              </td>
            </tr>
          </tbody>
          <div class="subtitle mx-4 mt-7">{{ __("registo") }}</div>
          <tbody>
            <tr>
              <th>{{ __("registado por") }}</th>
              <td>
                {{ video_call.created_by ? video_call.created_by.name : "---" }}
              </td>
            </tr>
            <tr>
              <th>{{ __("data de registo") }}</th>
              <td>
                {{ video_call.created_at }}
              </td>
            </tr>
            <tr>
              <th>{{ __("última alteração") }}</th>
              <td>
                {{ video_call.updated_at }}
              </td>
            </tr>
          </tbody>
          <tbody></tbody>
        </v-simple-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import i18n from "@/mixins/i18n";

export default {
  mixins: [i18n],
  data() {
    return {
      i18n_prefix: "video_call",
      dialog: false,
      video_call: null,
    };
  },

  methods: {
    init(video_call) {
      this.video_call = video_call;
      this.dialog = true;
    },
    handleClose() {
      this.dialog = false;
      this.$emit("close");
    },
  },
};
</script>
